import { Button, Card, CardActions, CardContent, CardHeader, Divider, Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import EditIcon from '@material-ui/icons/Edit';
import clsx from 'clsx';
import { BookingPrice, MonoText } from 'components';
import moment from "moment";
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import snakeToCamel from "utils/snakeToTitle";
import { BookingEdit } from './components';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  actions: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > * + *': {
      marginLeft: 0
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  header: {
    fontWeight: 600
  }
}));

const BookingInfo = props => {
  const { className, ...rest } = props;
  const model = useSelector(state => state.models.booking);

  const classes = useStyles();

  const [openEdit, setOpenEdit] = useState(false);

  const handleEditOpen = () => {
    setOpenEdit(true);
  };

  const handleEditClose = () => {
    setOpenEdit(false);
  };

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Booking Info" />
      <Divider />
      <CardContent className={classes.content}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell className={classes.header}>Date Created</TableCell>
              <TableCell>{moment(model.created_at).format("DD/MM/YYYY - HH:mm")}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Reference</TableCell>
              <TableCell><MonoText>{model.reference}</MonoText></TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Price</TableCell>
              <TableCell><BookingPrice model={model} /></TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Status</TableCell>
              <TableCell>{snakeToCamel(model.status)}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
      <CardActions className={classes.actions}>
        <Button onClick={handleEditOpen}>
          <EditIcon className={classes.buttonIcon} />
          Edit
        </Button>
      </CardActions>
      <BookingEdit onClose={handleEditClose} open={openEdit} />
    </Card>
  );
};

BookingInfo.propTypes = {
  className: PropTypes.string,
};

export default BookingInfo;
